import { useRef, useState } from "react";

import { useImagePostModalStore } from "../../store";
import { MainImage } from "./MainImage";
import { Thumbnails } from "./Thumbnails";

export const Carousel = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { uploadedImages } = useImagePostModalStore();
  const prevLengthRef = useRef(uploadedImages.length);
  const prevLength = prevLengthRef.current;
  const newLength = uploadedImages.length;

  // if the last image is deleted, move to the new last image.
  if (newLength > 0 && currentImageIndex > newLength - 1) {
    setCurrentImageIndex(uploadedImages.length - 1);
  } // If new images are added, update the currentImageIndex to the first new image
  else if (newLength > prevLength) {
    setCurrentImageIndex(prevLength);
  }

  // update the reference to the new length
  prevLengthRef.current = newLength;

  return (
    <div className="flex w-full min-w-0 flex-col lg:h-full lg:min-h-0">
      <MainImage currentImageIndex={currentImageIndex} />
      {uploadedImages.length > 0 && (
        <Thumbnails
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </div>
  );
};
